import {
  CHECK_ALREADY_ANSWERED,
  CHECK_ALREADY_ANSWERED_CLEAR,
  CHECK_ALREADY_ANSWERED_ERROR,
  CHECK_ALREADY_ANSWERED_SUCCESS,
  CHECK_ANSWER,
  CHECK_ANSWER_ERROR,
  CHECK_ANSWER_LOADING,
  CHECK_ANSWER_SUCCESS,
  GET_HOME_BANNER,
  GET_HOME_BANNER_ERROR,
  GET_HOME_BANNER_LOADING,
  GET_HOME_BANNER_SUCCESS,
  GET_HOME_COURSE,
  GET_HOME_COURSE_ERROR,
  GET_HOME_COURSE_LOADING,
  GET_HOME_COURSE_SUCCESS,
  GET_QUESTION_OF_THE_DAY,
  GET_QUESTION_OF_THE_DAY_ERROR,
  GET_QUESTION_OF_THE_DAY_LOADING,
  GET_QUESTION_OF_THE_DAY_SUCCESS,
} from "./constants";

const banners = {
  data: [],
  error: "",
  success: false,
  loading: false,
};

const courses = {
  data: [],
  error: "",
  success: false,
  loading: false,
};

const subscribedCoures = {
  data: [],
};

const questionOfDay = {
  data: {},
  error: "",
  success: false,
  loading: false,
};

const qodAnswer = {
  data: null,
  success: false,
  error: "",
};

const answer = {
  data: null,
  error: "",
  success: false,
  loading: false,
};

const initialState = {
  banners: { ...banners },
  courses: { ...courses },
  subscribedCoures: { ...subscribedCoures },
  questionOfDay: { ...questionOfDay },
  qodAnswer: { ...qodAnswer },
  answer: { ...answer },
};

const homeReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_HOME_BANNER:
      return { ...state, ...banners };
    case GET_HOME_BANNER_LOADING:
      return { ...state, banners: { ...banners, loading: true } };
    case GET_HOME_BANNER_SUCCESS:
      return {
        ...state,
        banners: { ...banners, success: true, data: payload },
      };
    case GET_HOME_BANNER_ERROR:
      return { ...state, banners: { ...banners, error: payload } };
    case GET_HOME_COURSE:
      return { ...state, ...courses, ...subscribedCoures };
    case GET_HOME_COURSE_LOADING:
      return {
        ...state,
        courses: { ...courses, loading: true },
        subscribedCoures: { ...subscribedCoures },
      };
    case GET_HOME_COURSE_SUCCESS:
      return {
        ...state,
        courses: { ...courses, data: payload.courses, success: true },
        subscribedCoures: { data: payload.subscribedCourses },
      };
    case GET_HOME_COURSE_ERROR:
      return {
        ...state,
        courses: { ...courses, error: payload },
        subscribedCoures: { data: [] },
      };
    case GET_QUESTION_OF_THE_DAY:
      return { ...state, ...questionOfDay };
    case GET_QUESTION_OF_THE_DAY_LOADING:
      return { ...state, questionOfDay: { ...questionOfDay, loading: true } };
    case GET_QUESTION_OF_THE_DAY_SUCCESS:
      return {
        ...state,
        questionOfDay: { ...questionOfDay, success: true, data: payload },
      };
    case GET_QUESTION_OF_THE_DAY_ERROR:
      return { ...state, questionOfDay: { ...questionOfDay, error: payload } };
    case CHECK_ALREADY_ANSWERED:
      return { ...state, ...qodAnswer };
    case CHECK_ALREADY_ANSWERED_SUCCESS:
      return {
        ...state,
        qodAnswer: { ...qodAnswer, success: true, data: payload },
      };
    case CHECK_ALREADY_ANSWERED_ERROR:
      return { ...state, qodAnswer: { ...qodAnswer, error: payload } };
    case CHECK_ALREADY_ANSWERED_CLEAR:
      return {
        ...state,
        qodAnswer: { ...qodAnswer },
        questionOfDay: { ...questionOfDay },
      };
    case CHECK_ANSWER:
      return { ...state, ...answer };
    case CHECK_ANSWER_LOADING:
      return { ...state, answer: { ...answer, loading: true } };
    case CHECK_ANSWER_SUCCESS:
      return { ...state, answer: { ...answer, success: true, data: payload } };
    case CHECK_ANSWER_ERROR:
      return { ...state, answer: { ...answer, error: payload } };
    default:
      return { ...state };
  }
};

export default homeReducer;
